import React from "react";
import "./admin.css";
import AdminTour from "./components/AdminTour";

function Admin({ children }) {
  const redirectGameSession = () => {
    let getGameId = JSON.parse(localStorage.getItem("userData"));
    getGameId = getGameId.gameId;
    window.location.href =
      process.env.REACT_APP_BASE_URL + "/active-games/" + getGameId;
  };

  return (
    <div className="admin-background">
      <div className="header-admin">
        <div className="brand-logo-and-game-holder">
          <div
            className="brand-logo-holder"
            onClick={() => {
              window.location.href = process.env.REACT_APP_BASE_URL;
            }}
          >
            <img src="/admin/play.png" className="brand-logo" alt="Play" />
            {localStorage.getItem("session") === "admin&admin" && " SUPERADMIN"}
          </div>
          <div onClick={() => redirectGameSession()}>Colours of choice </div>
        </div>

        <div className="header-admin-right">
          <AdminTour />
          <div className="user">
            <img src="/admin/user.png" alt="" />
          </div>
        </div>
      </div>
      {children}
    </div>
  );
}

export default Admin;
